module.exports = __webpack_public_path__ + "img/rpm-16-days.9520720.png";